(function () {
  "use strict";
  document.querySelectorAll('[data-dv-sticky]').forEach(function (bar) {
    var root = bar.closest('.dv-funnel');
    var primary = root && root.querySelector('.dv-hero .tgbc-buybox__cta');
    if (!primary) return;
    var pending = false;
    function apply() {
      pending = false;
      var rect = primary.getBoundingClientRect();
      var header = document.querySelector('sticky-header');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var primaryVisible = rect.width > 0 && rect.top >= headerBottom && rect.bottom <= window.innerHeight;
      bar.classList.toggle('is-on', !primaryVisible);
      bar.setAttribute('aria-hidden', primaryVisible ? 'true' : 'false');
      bar.inert = primaryVisible;
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(apply);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(schedule, { threshold: [0, 1] }).observe(primary);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    apply();
  });
})();

/* Hero gallery: clicking a thumbnail swaps the main image.
   Delegated from document so theme-editor block re-renders keep working. */
(function(){
  "use strict";
  function selectGalleryImage(root, thumb) {
    var main = root.querySelector('.dv-hero__main img');
    var full = thumb.getAttribute('data-full');
    if (!main || !full) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = full;
    main.alt = thumb.getAttribute('data-alt') || '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-dv-thumb]'), function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }
  document.addEventListener('click', function (ev) {
    var nav = ev.target && ev.target.closest ? ev.target.closest('[data-dv-gallery-nav]') : null;
    if (nav) {
      var navRoot = nav.closest('[data-dv-gallery]');
      var thumbs = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('[data-dv-thumb]')) : [];
      if (!thumbs.length) return;
      var current = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      var direction = nav.getAttribute('data-dv-gallery-nav') === 'prev' ? -1 : 1;
      var next = (current + direction + thumbs.length) % thumbs.length;
      selectGalleryImage(navRoot, thumbs[next]);
      return;
    }
    var thumb = ev.target && ev.target.closest ? ev.target.closest('[data-dv-thumb]') : null;
    if (!thumb) return;
    var root = thumb.closest('[data-dv-gallery]');
    if (!root) return;
    selectGalleryImage(root, thumb);
  });
})();

(function () {
  "use strict";
  var slot = document.querySelector('.dv-hero [data-kells-paypal-slot]');
  if (!slot) return;
  function placeMessage() {
    var message = document.getElementById('paypal-upstream-messaging-product');
    if (!message) return;
    if (message.parentElement !== slot) slot.appendChild(message);
    observer.disconnect();
  }
  var observer = new MutationObserver(placeMessage);
  observer.observe(document.body, { childList: true, subtree: true });
  placeMessage();
  document.addEventListener('shopify:section:unload', function () { observer.disconnect(); }, { once: true });
})();
